import { _ as __rest, a as __assign } from '../../tslib.es6-21effb23.js';
import * as React from 'react';
import { Typography } from './Typography.js';
import '../../index-29eed6c4.js';
import '../../skeleton.module-4f527a2f.js';

var styles = {"title":"EntityInfo_title_4e6a9c69","subtitle":"EntityInfo_subtitle_4e6a9c69"};

var EntityInfo = React.forwardRef(function EntityInfo(props, ref) {
    var className = props.className, title = props.title, subtitle = props.subtitle, otherProps = __rest(props, ["className", "title", "subtitle"]);
    return (React.createElement("div", __assign({ ref: ref, className: className }, otherProps),
        React.createElement(Typography, { className: styles.title, variant: "p", as: "p", "data-testid": "entityinfo-title" }, title),
        React.createElement(Typography, { className: styles.subtitle, variant: "extraSmall", as: "div", "data-testid": "entityinfo-subtitle" }, subtitle)));
});

export { EntityInfo };
